"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AsyncResourceValueSelect;
var _deepObjectDiff = require("deep-object-diff");
var _lodash = require("lodash");
var _objectHash = _interopRequireDefault(require("object-hash"));
var _react = require("react");
var _hooks = require("../hooks");
var _utils = require("../utils");
var _AsyncResourceFiltersCache = _interopRequireDefault(require("./AsyncResourceFiltersCache"));
var _AsyncSelect = _interopRequireDefault(require("./AsyncSelect"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function AsyncResourceValueSelect(props) {
  const {
    appName,
    cacheFirstPage,
    displayPropertyName,
    filters,
    keyPropertyName,
    networkFilters,
    contextFilters,
    resourceName,
    resourceType,
    service,
    backupId,
    defaultSort,
    showCheckBoxes = false,
    limitTags = 4,
    ...rest
  } = props;
  const [error, setError] = (0, _react.useState)(false);
  const controlField = displayPropertyName ?? keyPropertyName;
  const totalFilteredRecords = (0, _react.useRef)(0);
  const keyHash = (0, _objectHash.default)({
    filters,
    networkFilters,
    controlField,
    contextFilters
  });
  const prevContextFilters = (0, _hooks.usePrevious)(contextFilters);
  const resetFilter = !(0, _lodash.isEmpty)((0, _deepObjectDiff.diff)(contextFilters, prevContextFilters));
  const selectApi = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    selectApi.current.reset();
  }, [resetFilter]);
  async function handleOptionsRequest(searchText, pageIndex, onCancel) {
    if (error) setError(false);
    const shouldCache = cacheFirstPage && !searchText && pageIndex === 1;
    if (shouldCache && _AsyncResourceFiltersCache.default?.[resourceName] && keyHash in _AsyncResourceFiltersCache.default[resourceName]) return _AsyncResourceFiltersCache.default[resourceName][keyHash];
    const cleanedFilters = (0, _utils.cleanFilters)(filters);
    const filterFields = (0, _utils.getFilterFields)(cleanedFilters).map(f => f.name);
    const fieldNames = (0, _lodash.uniq)([controlField, keyPropertyName, ...filterFields]).map(n => n.indexOf(' ') >= 0 ? `[${n}]` : n).join(',');
    const search = {
      controlField,
      sort: defaultSort === 2 ? 'd' : 'a',
      filters: (0, _utils.filtersToString)(cleanedFilters),
      fieldNames,
      networkFilters: networkFilters?.join(', '),
      contextFilters,
      pageSize: 250,
      pageIndex,
      searchText,
      resourceType
    };
    try {
      const res = await service(appName, resourceName, search, backupId, onCancel);
      if (res.totalRecords != null) totalFilteredRecords.current = res.totalRecords;
      const options = (0, _lodash.uniqBy)(res.values, controlField).map(v => ({
        value: String(v[keyPropertyName]),
        label: String(v[controlField])
      }));
      const result = {
        options,
        totalRecords: totalFilteredRecords.current
      };
      if (shouldCache) {
        _AsyncResourceFiltersCache.default[resourceName] = _AsyncResourceFiltersCache.default[resourceName] || {};
        _AsyncResourceFiltersCache.default[resourceName][keyHash] = result;
      }
      return result;
    } catch (err) {
      if (err.__CANCEL__) return;
      console.error(err);
      setError(true);
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AsyncSelect.default, {
    multiple: true,
    requestStart: "mount",
    disableCloseOnSelect: true,
    filterSelectedOptions: true,
    limitTags: limitTags,
    onOptionsRequest: handleOptionsRequest,
    ChipProps: {
      size: 'small'
    },
    onLoad: api => selectApi.current = api,
    ...rest,
    textFieldProps: {
      size: 'small',
      ...(error && {
        error,
        helperText: 'Failed to load options'
      }),
      ...rest.textFieldProps
    },
    showCheckBoxes: showCheckBoxes
  }, keyHash);
}